import { GenerationParameters, ProductionDrawing } from './production-drawing.dto';

export enum Base {
  DC = 'DC',
  DP = 'DP',
  DG = 'DG',
  FLEX = 'FLEX',
  ELITE = 'ELITE',
  MONOPOST = 'MONOPOST',
  MONOPOST_FLEX = 'MONOPOST_FLEX',
  DS = 'DS',
  DSXL = 'DSXL',
  DS_EXT = 'DS_EXT',
  DS_EXT_XL = 'DS_EXT_XL',
}

export enum StdBasePlateType {
  STD = 'STD',
  HD = 'HD',
  LONG = 'LONG',
  NO_NOSE = 'NO_NOSE',
  SEISMIC = 'SEISMIC',
  SEISMIC_LONG = 'SEISMIC_LONG',
  SEISMIC_NO_NOSE = 'SEISMIC_NO_NOSE',
}

export enum DgBasePlateType {
  DG = 'DG',
  DG_SEISMIC = 'DG_SEISMIC',
}

export const BasePlateType = {
  ...StdBasePlateType,
  ...DgBasePlateType,
};

export enum UnitType {
  STD = 'STD',
  DBRS = 'DBRS',
  ELITE_DOUBLE_LEG = 'ELITE_DOUBLE_LEG',
}

export interface UnitMeasurements {
  SEAT_HEIGHT?: number;
  A?: number;
  B?: number;
  C1?: number;
  C2?: number;
  D1?: number;
  D2?: number;
  E1?: number;
  E2?: number;
  F1?: number;
  F2?: number;
  G?: number;
  H?: number;
  I?: number;
  J1?: number;
  J2?: number;
  K?: number;
  L?: number;
  M?: number;
  N?: number;
  O?: number;
  P?: number;
  Q?: number;
  R?: number;
  S?: number;
  FBP_WIDTH?: number;
  FBP_LENGTH?: number;
  FBP_THICKNESS?: number;
  BBP_WIDTH?: number;
  BBP_LENGTH?: number;
  BBP_THICKNESS?: number;
  LENGTH?: number;
}

export interface BeamMeasurements {
  bottomClip?: number;
  bottomBeam?: number;
  height?: number;
  width?: number;
}

export interface UnitGenerationParameters extends GenerationParameters {
  supplier?: string;
  product?: string;
  frontBasePlateType?: StdBasePlateType | DgBasePlateType;
  frontBasePlateAnchorCount?: number;
  backBasePlateType?: StdBasePlateType | DgBasePlateType;
  backBasePlateAnchorCount?: number;
  beamMeasurements?: BeamMeasurements[];
  type?: UnitType;
}

export interface UnitProductionDrawing extends ProductionDrawing {
  params?: UnitParams;
}

export interface UnitParams {
  drawingParameters?: UnitGenerationParameters;
}
